<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>



<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row" *ngIf="SelectedpatientDetails">
          <div class="col-md-1 ">
            <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.RecepientPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-4 padding-left-0px">
            <div class="row row-height-17px margin-left-0px">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.RecepientName}} </label>
              </div>
            </div>
            <div class="row row-height-17px margin-left-0px" *ngIf="ReceipentMember">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{ReceipentMember.MemberDisplayName}}) </label>
              </div>
            </div>
            <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
              </div>
            </div>-->
            <div class="row row-height-17px">
              <div class="col-md-12">
                
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.RecepientAgeYears}},{{SelectedpatientDetails.RecepientFormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.RecepientTelephone1}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-2 padding-right-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
              </div>
              <div class="col-md-9 padding-left-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
              </div>

            </div>

          </div>
          <div class="col-md-6  padding-right-0px">
            <!--<div class="row font-size-12px">
    <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
    </div>:
    <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
    </div>
  </div>-->
            <div class="row font-size-12px">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="EmbryoTransferData2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{EmbryoTransferData2.ActivityStatus}}</label>
              </div>
            </div>
         
            <!--<div class="row">
    <div class="col-md-1 margin-left-auto padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
      </div>
    <div class="col-md-1 padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
    </div>

     <div class="col-md-1 padding-left-7px">

      <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
    </div>

  </div>-->
            <div class="row margin-right-0px" hidden>
              <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
              </div>
              <div class="Dsa2" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
              </div>
              <div class="Dsa3" *ngIf="DSADetails">

                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.close('Load')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="card">
       
          <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
            <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
              <div class="col-md-6 padding-right-0px">
                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                  Embryo Transfer
                </label>
              </div>
              <div class="col-md-5  padding-right-0px padding-left-0px" *ngIf="GradingModel &&  SelectedpatientDetails">
                <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                <div class="row float-right" *ngIf="GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                  <div class="col-md-12 margin-top-3px padding-left-0px padding-right-0px" *ngIf="EmbryoTransferData2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="EmbryoTransfer()" title="Embryo Transfer Completed" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Embryo Transfer Completed</a>
                  </div>

                  <div class="col-md-1" >
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransfer()" hidden>
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>
                </div>

                <div class="row float-right" *ngIf="EmbryoTransferData2">
                  <div class="col-md-12 margin-top-3px padding-left-0px padding-right-0px" >
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="EmbryoTransfer()" title="Embryo Transfer Completed" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Embryo Transfer Completed</a>
                  </div>

                  <div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransferdroplet()" hidden>
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>
                </div>
              
              </div>

            </div>
          </div>
          <div class="chatsd product-chart-wrapper product-chat-follicular-popup agreement-chart-wrapper ps  padding-lrt " data-ps-id="dfsfsde">
            <div class="card-body" *ngIf="GradingModel">
              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample2" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Schedule
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit" [disabled]="DateOfBirth.errors?.required || ActivityTime.errors?.required" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">


                              <!--<div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">


                      <div class="row font-size-12px">
                        <div class="col-md-3  text-align-right padding-right-5px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Planned Time </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px  padding-left-9px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.TransferDate}}</label>
                        </div>
                      </div>
                    </div>
                  </div>-->
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Date </label>
                                    </div>


                                    <div class="col-md-3 padding-right-0px">

                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp1" [(ngModel)]="TransferEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                        <small class="form-text text-danger"
                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Time </label>
                                    </div>


                                    <div class="col-md-3 padding-right-0px">

                                      <input type="time" class="form-control" id="EmbryoTransFerEndInfo.TransferEndTime" placeholder="Trigger Time"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferEndTime"
                                             name="EmbryoTransFerEndInfo.TransferEndTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" required />

                                    </div>

                                  </div>


                                </div>
                              </div>




                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample2" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Schedule
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>

                        </div>


                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Actual Date </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">

                                      <!--<div class="date-form">
                            <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                   name="dp1" [(ngModel)]="TransferEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                            <a (click)="d1.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>

                          </div>-->

                                      <label class="margin-bottom-0px ">{{EmbryoTransFerEndInfo.TransferEndDate | date:'MMM-dd-yyyy'}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Actual Time </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">

                                      <!--<input type="time" class="form-control" id="EmbryoTransFerEndInfo.TransferEndTime" placeholder="Trigger Time"
                          [(ngModel)]="EmbryoTransFerEndInfo.TransferEndTime"
                          name="EmbryoTransFerEndInfo.TransferEndTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->

                                      <label class="margin-bottom-0px ">{{EmbryoTransFerEndInfo.TransferEndTime| slice:11}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>




                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f2="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample3" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThree">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                Team
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit" [disabled]="EmbryoTransFerEndInfo.Surgeon==0 || EmbryoTransFerEndInfo.AsstSurgeon==0 || EmbryoTransFerEndInfo.Embryologist==0 || EmbryoTransFerEndInfo.Anesthesiologist==0" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample3">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Surgeon </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                               id="EmbryoTransFerEndInfo.Surgeon" SelectedValue="EmbryoTransFerEndInfo.Surgeon"
                                                               [(ngModel)]="EmbryoTransFerEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                               name="EmbryoTransFerEndInfo.Surgeon" required>
                                      </CustomDataByRequestType>
                                      <!--<CodeTypeValue CodeType="FNSTS">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          name="CurrentEditCounsellingPalnRequest.FinancialStatus">-->
                                      <!--</CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Asst.Surgeon </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                               id="EmbryoTransFerEndInfo.AsstSurgeon" SelectedValue=""
                                                               [(ngModel)]="EmbryoTransFerEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                               name="EmbryoTransFerEndInfo.AsstSurgeon" required #sign1="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<CodeTypeValue CodeType="FNSTS">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          name="CurrentEditCounsellingPalnRequest.FinancialStatus">-->
                                      <!--</CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Embryologist </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                               id="EmbryoTransFerEndInfo.Embryologist" SelectedValue=""
                                                               [(ngModel)]="EmbryoTransFerEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeAsstSurgeon2($event)"
                                                               name="EmbryoTransFerEndInfo.Embryologist" required>
                                      </CustomDataByRequestType>
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthesiologist </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                               id="EmbryoTransFerEndInfo.Anesthesiologist" SelectedValue="EmbryoTransFerEndInfo.Anesthesiologist"
                                                               [(ngModel)]="EmbryoTransFerEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                               name="EmbryoTransFerEndInfo.Anesthesiologist">
                                      </CustomDataByRequestType>
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthesia </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CodeTypeValue CodeType="IVFAT"
                                                     id="EmbryoTransFerEndInfo.AnaesthesiaType"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.AnaesthesiaType" SelectedValue="EmbryoTransFerEndInfo.AnaesthesiaType"
                                                     name="EmbryoTransFerEndInfo.AnaesthesiaType">
                                      </CodeTypeValue>
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample3" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThree">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                Team
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>

                        </div>


                      </div>

                      <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample3">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Surgeon </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                   id="EmbryoTransFerEndInfo.Surgeon" SelectedValue="EmbryoTransFerEndInfo.Surgeon"
                                                   [(ngModel)]="EmbryoTransFerEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                   name="EmbryoTransFerEndInfo.Surgeon" required>
                          </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.SurgeonName}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Asst.Surgeon </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                   id="EmbryoTransFerEndInfo.AsstSurgeon" SelectedValue="EmbryoTransFerEndInfo.AsstSurgeon"
                                                   [(ngModel)]="EmbryoTransFerEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                   name="EmbryoTransFerEndInfo.AsstSurgeon" required>
                          </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.AsstSurgeonName}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Embryologist </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                   id="EmbryoTransFerEndInfo.Embryologist" SelectedValue=""
                                                   [(ngModel)]="EmbryoTransFerEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeAsstSurgeon2($event)"
                                                   name="EmbryoTransFerEndInfo.Embryologist" required>
                          </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.EmbryologistName}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Anaesthesiologist </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                   id="EmbryoTransFerEndInfo.Anesthesiologist" SelectedValue="EmbryoTransFerEndInfo.Anesthesiologist"
                                                   [(ngModel)]="EmbryoTransFerEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                   name="EmbryoTransFerEndInfo.Anesthesiologist" required>
                          </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.AnesthesiologistName}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Anaesthesia </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CodeTypeValue CodeType="IVFAT"
                                         id="EmbryoTransFerEndInfo.AnaesthesiaType"
                                         [(ngModel)]="EmbryoTransFerEndInfo.AnaesthesiaType" SelectedValue="EmbryoTransFerEndInfo.AnaesthesiaType"
                                         name="EmbryoTransFerEndInfo.AnaesthesiaType">
                          </CodeTypeValue>-->
                                      <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.AnaesthesiaType}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitTransferDetails()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                Transfer Details
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">


                              <div class="card margin-bottom-0px border-all-1px">
                                <div class="card-body padding-all-0px">
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row margin-top-5px">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-10 margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Type of Transfer </label>
                                        </div>


                                        <div class="col-md-3">
                                          <CodeTypeValue CodeType="TOT"
                                                         id="EmbryoTransFerEndInfo.TypeOfTransfer"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.TypeOfTransfer" SelectedValue="EmbryoTransFerEndInfo.TypeOfTransfer"
                                                         name="EmbryoTransFerEndInfo.TypeOfTransfer">
                                          </CodeTypeValue>
                                          <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                          <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                          <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Day Of Transfer </label>
                                        </div>


                                        <div class="col-md-3 padding-right-0px">
                                          <CodeTypeValue CodeType="DOTRS"
                                                         id="EmbryoTransFerEndInfo.DayOfTransfer"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.DayOfTransfer" SelectedValue="EmbryoTransFerEndInfo.DayOfTransfer"
                                                         name="EmbryoTransFerEndInfo.DayOfTransfer">
                                          </CodeTypeValue>


                                        </div>


                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Culture Media Used </label>
                                        </div>


                                        <div class="col-md-3">
                                          <CodeTypeValue CodeType="CULME"
                                                         id="EmbryoTransFerEndInfo.CultureMedia"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                                         name="EmbryoTransFerEndInfo.CultureMedia">
                                          </CodeTypeValue>
                                          <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                          <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                          <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Speculum Used </label>
                                        </div>


                                        <div class="col-md-3 padding-right-0px">
                                          <CodeTypeValue CodeType="SPECU"
                                                         id="EmbryoTransFerEndInfo.Speculum"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.Speculum" SelectedValue="EmbryoTransFerEndInfo.Speculum"
                                                         name="EmbryoTransFerEndInfo.Speculum">
                                          </CodeTypeValue>


                                        </div>


                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Thawing Media Used </label>
                                        </div>


                                        <div class="col-md-3">
                                          <CodeTypeValue CodeType="THWMD"
                                                         id="EmbryoTransFerEndInfo.ThawingMedia"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.ThawingMedia" SelectedValue="EmbryoTransFerEndInfo.ThawingMedia"
                                                         name="EmbryoTransFerEndInfo.ThawingMedia">
                                          </CodeTypeValue>

                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Method </label>
                                        </div>


                                        <div class="col-md-3 padding-right-0px">
                                          <CodeTypeValue CodeType="TRNSM"
                                                         id="EmbryoTransFerEndInfo.TransferMethod"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                                         name="EmbryoTransFerEndInfo.TransferMethod">
                                          </CodeTypeValue>
                                          <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                          <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                          <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                        </div>

                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Type </label>
                                        </div>


                                        <div class="col-md-3">
                                          <CodeTypeValue CodeType="CATUS"
                                                         id="EmbryoTransFerEndInfo.CatheterType"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.CatheterType" SelectedValue="EmbryoTransFerEndInfo.CatheterType"
                                                         name="EmbryoTransFerEndInfo.CatheterType">
                                          </CodeTypeValue>

                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Used </label>
                                        </div>


                                        <div class="col-md-3 padding-right-0px">
                                          <CodeTypeValue CodeType="CATTY"
                                                         id="EmbryoTransFerEndInfo.Catheter"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.Catheter" SelectedValue="EmbryoTransFerEndInfo.Catheter"
                                                         name="EmbryoTransFerEndInfo.Catheter">
                                          </CodeTypeValue>
                                          <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                          <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                          <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                        </div>


                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto padding-left-0px">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Media Cleaning of Cervical Canal </label>
                                        </div>


                                        <div class="col-md-3">
                                          <CodeTypeValue CodeType="CERCL"
                                                         id="EmbryoTransFerEndInfo.CervicalCleaning"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.CervicalCleaning" SelectedValue="EmbryoTransFerEndInfo.CervicalCleaning"
                                                         name="EmbryoTransFerEndInfo.CervicalCleaning">
                                          </CodeTypeValue>


                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto">
                                          <!--<label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Method </label>-->
                                        </div>


                                        <div class="col-md-3 padding-right-0px">
                                          <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                        </div>

                                      </div>


                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="card margin-bottom-0px border-all-1px margin-top-10">
                                <div class="card-body padding-all-0px">
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retained Embryos </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                          <!--<CodeTypeValue CodeType="FNSTS"
                                             id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                             [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                             name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                              </CodeTypeValue>-->
                                          <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                          <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                          <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                        </div>

                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-15px ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Technique </label>
                                        </div>


                                        <div class="col-md-3 margin-top-10">
                                          <CodeTypeValue CodeType="IVFAT"
                                                         id="EmbryoTransFerEndInfo.Technique"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.Technique" SelectedValue="EmbryoTransFerEndInfo.Technique"
                                                         name="EmbryoTransFerEndInfo.Technique">
                                          </CodeTypeValue>


                                        </div>

                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto " hidden>
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Fragmentation </label>
                                        </div>
                                        <div class="col-md-1" hidden>
                                          <!--<CodeTypeValue CodeType="FNSTS"
                                                 id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                               [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                              name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                </CodeTypeValue>-->
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasFragmentation" name="EmbryoTransFerEndInfo.HasFragmentation">
                                        </div>
                                        <div class="col-md-1 padding-left-0px margin-top-3px padding-right-0px" *ngIf="EmbryoTransFerEndInfo.HasFragmentation" hidden>
                                          <input type="number" class="form-control" placeholder="%"
                                                 id="EmbryoTransFerEndInfo.Fragmentation"
                                                 [(ngModel)]="EmbryoTransFerEndInfo.Fragmentation"
                                                 name="EmbryoTransFerEndInfo.Fragmentation" #Doctor="ngModel"
                                                 maxlength="100" required>

                                          <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Stilette </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasStilette" name="EmbryoTransFerEndInfo.HasStilette">


                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Dilator </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasDilator" name="EmbryoTransFerEndInfo.HasStilette">


                                        </div>

                                      </div>


                                    </div>
                                  </div>
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cervical Mucus </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.CervicalMucus" name="EmbryoTransFerEndInfo.CervicalMucus">


                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retransfer </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetransfer" name="EmbryoTransFerEndInfo.HasRetransfer">


                                        </div>

                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Blood on Catheter </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.BloodOnCatheter" name="EmbryoTransFerEndInfo.BloodOnCatheter">


                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryo Transfer </label>
                                        </div>


                                        <div class="col-md-3">
                                          <CodeTypeValue CodeType="IVFTP"
                                                         id="EmbryoTransFerEndInfo.TransferType"
                                                         [(ngModel)]="EmbryoTransFerEndInfo.TransferType" SelectedValue="EmbryoTransFerEndInfo.TransferType"
                                                         name="EmbryoTransFerEndInfo.TransferType">
                                          </CodeTypeValue>
                                          <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                          <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                          <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                        </div>
                                        <!--<div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Retransfer </label>
                            </div>


                            <div class="col-md-3">
                              <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetransfer" name="EmbryoTransFerEndInfo.HasRetransfer">


                            </div>-->
                                      </div>


                                    </div>
                                  </div>

                                  <!--<div class="row my-profile-form">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                          <div class="row">
                            <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Embryo Transfer </label>
                            </div>


                            <div class="col-md-3">
                              <CodeTypeValue CodeType="IVFTP"
                                             id="EmbryoTransFerEndInfo.TransferType"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferType" SelectedValue="EmbryoTransFerEndInfo.TransferType"
                                             name="EmbryoTransFerEndInfo.TransferType">
                              </CodeTypeValue>


                            </div>

                          </div>


                        </div>
                      </div>-->
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitTransferDetails()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                Transfer Details
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>

                        </div>


                      </div>

                      <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">


                              <div class="card margin-bottom-0px border-all-1px">
                                <div class="card-body padding-all-0px">
                                  <div class="row my-profile-form margin-top-10">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 text-align-right margin-top-3px">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Type of Transfer </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-3px">
                                          <!--<CodeTypeValue CodeType="CULME"
                                             id="EmbryoTransFerEndInfo.CultureMedia"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                             name="EmbryoTransFerEndInfo.CultureMedia">
                              </CodeTypeValue>-->

                                          <label class="margin-bottom-0px font-size-12px ">{{EmbryoTransFerEndInfo.TypeOfTransfer}}</label>

                                        </div>
                                        <div class="col-md-2 text-align-right margin-top-3px">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Day Of Transfer </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-3px">
                                          <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.DayOfTransfer}}</label>

                                        </div>

                                      </div>


                                    </div>
                                  </div>
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 text-align-right margin-top-3px ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Culture Media Used </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-3px">
                                          <!--<CodeTypeValue CodeType="CULME"
                                             id="EmbryoTransFerEndInfo.CultureMedia"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                             name="EmbryoTransFerEndInfo.CultureMedia">
                              </CodeTypeValue>-->

                                          <label class="margin-bottom-0px font-size-12px ">{{EmbryoTransFerEndInfo.CultureMedia}}</label>

                                        </div>
                                        <div class="col-md-2 text-align-right margin-top-auto margin-bottom-auto">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Speculum Used </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                          <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Speculum}}</label>

                                        </div>

                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Thawing Media Used </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                          <!--<CodeTypeValue CodeType="CULME"
                                             id="EmbryoTransFerEndInfo.CultureMedia"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                             name="EmbryoTransFerEndInfo.CultureMedia">
                              </CodeTypeValue>-->

                                          <label class="margin-bottom-0px font-size-12px ">{{EmbryoTransFerEndInfo.ThawingMedia}}</label>

                                        </div>
                                        <div class="col-md-2 text-align-right margin-top-auto margin-bottom-auto">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Method </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                          <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.TransferMethod}}</label>

                                        </div>

                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 text-align-right margin-top-3px ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Type </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-3px">
                                          <!--<CodeTypeValue CodeType="CATUS"
                                             id="EmbryoTransFerEndInfo.CatheterType"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CatheterType" SelectedValue="EmbryoTransFerEndInfo.CatheterType"
                                             name="EmbryoTransFerEndInfo.CatheterType">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.CatheterType}}</label>

                                        </div>
                                        <div class="col-md-2 text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Used </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                          <!--<CodeTypeValue CodeType="CATTY"
                                             id="EmbryoTransFerEndInfo.Catheter"
                                             [(ngModel)]="EmbryoTransFerEndInfo.Catheter" SelectedValue="EmbryoTransFerEndInfo.Catheter"
                                             name="EmbryoTransFerEndInfo.Catheter">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Catheter}}</label>

                                        </div>
                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Media Cleaning of Cervical Canal </label>
                                        </div>:


                                        <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                          <!--<CodeTypeValue CodeType="SPECU"
                                             id="EmbryoTransFerEndInfo.Speculum"
                                             [(ngModel)]="EmbryoTransFerEndInfo.Speculum" SelectedValue="EmbryoTransFerEndInfo.Speculum"
                                             name="EmbryoTransFerEndInfo.Speculum">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.CervicalCleaning}}</label>

                                        </div>
                                        <div class="col-md-2 text-align-right margin-tg-auto padding-left-0px">
                                          <!--<label for="diaplayName" class="font-size-12px margin-bottom-0px">Media Cleaning of Cervical Canal </label>-->
                                        </div>


                                        <div class="col-md-3 margin-top-auto margin-bottom-auto">

                                          <!--<label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.CervicalCleaning}}</label>-->

                                        </div>
                                      </div>


                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="card margin-bottom-0px border-all-1px margin-top-10">
                                <div class="card-body padding-all-0px">
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retained Embryos </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" name="EmbryoTransFerEndInfo.HasRetainedEmbryos">


                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-15px ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Technique </label>
                                        </div>


                                        <div class="col-md-3 margin-top-15px">
                                          <!--<CodeTypeValue CodeType="IVFAT"
                                             id="EmbryoTransFerEndInfo.Technique"
                                             [(ngModel)]="EmbryoTransFerEndInfo.Technique" SelectedValue="EmbryoTransFerEndInfo.Technique"
                                             name="EmbryoTransFerEndInfo.Technique">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Technique}}</label>

                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto " hidden>
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Fragmentation </label>
                                        </div>
                                        <div class="col-md-1" hidden>

                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasFragmentation" name="EmbryoTransFerEndInfo.HasFragmentation">
                                        </div>
                                        <div class="col-md-1 padding-left-0px margin-top-auto margin-bottom-auto padding-right-0px" *ngIf="EmbryoTransFerEndInfo.HasFragmentation" hidden>
                                          <!--<input type="number" class="form-control" placeholder="%"
                              id="EmbryoTransFerEndInfo.Fragmentation"
                              [(ngModel)]="EmbryoTransFerEndInfo.Fragmentation"
                              name="EmbryoTransFerEndInfo.Fragmentation" #Doctor="ngModel"
                              maxlength="100" required>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Fragmentation}}</label>

                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Stilette </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasStilette" name="EmbryoTransFerEndInfo.HasStilette">


                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Dilator </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasDilator" name="EmbryoTransFerEndInfo.HasStilette">


                                        </div>

                                      </div>


                                    </div>
                                  </div>
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cervical Mucus </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.CervicalMucus" name="EmbryoTransFerEndInfo.CervicalMucus">


                                        </div>
                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retransfer </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetransfer" name="EmbryoTransFerEndInfo.HasRetransfer">


                                        </div>

                                      </div>


                                    </div>
                                  </div>

                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                      <div class="row">
                                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Blood on Catheter </label>
                                        </div>


                                        <div class="col-md-3">
                                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.BloodOnCatheter" name="EmbryoTransFerEndInfo.BloodOnCatheter">


                                        </div>


                                        <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryo Transfer </label>
                                        </div>


                                        <div class="col-md-3 margin-top-7px">
                                          <!--<CodeTypeValue CodeType="IVFTP"
                                             id="EmbryoTransFerEndInfo.TransferType"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferType" SelectedValue="EmbryoTransFerEndInfo.TransferType"
                                             name="EmbryoTransFerEndInfo.TransferType">
                              </CodeTypeValue>-->

                                          <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.TransferType}}</label>

                                        </div>
                                      </div>


                                    </div>
                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="row margin-left-0px margin-top-15px" *ngIf="GradingModel=='Well Culture'">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample9">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingnine">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsenine" aria-expanded="true" aria-controls="collapsenine">
                                Embryo Grading
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="button"
                        class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                        name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                  <i class="fas fa-plus font-size-11"></i>
                </button>-->
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapsenine" class="collapse show" aria-labelledby="headingnine" data-parent="#accordionExample9">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">
                                    <thead class="">
                                      <tr>

                                        <th class="min-width-0px padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px">
                                          S.No
                                        </th>

                                        <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px">DOC</th>

                                        <!--<th class="td-well-width-79px">
                              Well #
                            </th>

                            <th class="th-width-95px">Denuded</th>
                            <th>
                              Ins.Tech
                            </th>-->
                                        <!--<th class="">
                              Day1
                            </th>
                            <th class="">
                              Day2
                            </th>
                            <th class="">
                              Day3
                            </th>

                            <th class="">
                              Day4
                            </th>

                            <th class="">
                              Day5
                            </th>
                            <th class="">
                              Day6
                            </th>-->
                                        <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px">Details</th>
                                        <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px"></th>

                                        <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px"> Is Transferred</th>


                                      </tr>
                                    </thead>

                                    <tbody class="table-body">
                                      <tr *ngFor="let l of CurrentSingleWellCultureByCycleCodeController;let i = index">

                                        <td class="padding-top-0px padding-bottom-0px">{{i+1}}</td>
                                        <td class="padding-top-0px padding-bottom-0px">{{GetMaxDOC(l)}}</td>
                                        <td class="padding-top-0px padding-bottom-0px">
                                          <div *ngIf="GradingModel=='Well Culture'">Well # : {{l.WellNo}}</div>
                                          <div *ngIf="GradingModel=='Droplet Culture'">Number : </div>
                                          <div>Ins.Tech : {{l.Technique}} </div>
                                          <div>Denuded : {{l.OocyteQualityPost}}</div>
                                        </td>



                                        <td class="padding-top-0px padding-bottom-0px">

                                          <div class="card border-all-1px nav-link-hand margin-bottom-0px">

                                            <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">

                                              <div class="row margin-left-0px">
                                                <div>
                                                  <label class="margin-left-3px">{{GetMaxGrade(l)}}</label>
                                                </div>
                                                <div>
                                                  <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="l.Image1" onError="this.src='dummy.jpg';">
                                                </div>

                                              </div>


                                            </div>

                                          </div>

                                        </td>




                                        <td class="padding-top-0px padding-bottom-0px  padding-right-0px ">
                                          <!--<button (click)="SaveTransfered(l)" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new " *ngIf="!l.IsTransFerred">Confirm </button>-->
                                          <button (click)="SaveTransfered(l)" class="btn actions-btn-prime font-size-13px" *ngIf="!l.IsTransFerred">Confirm </button>
                                          <div class="row margin-left-0px margin-right-0px" *ngIf="l.IsTransFerred">
                                            <div class="col-md-1 padding-left-4">
                                              <i class="fas fa-check-circle color-icon-completed font-size-23px"></i>
                                            </div>
                                            <div class="col-md-10 padding-right-0px text-align-left">
                                              <label class="margin-bottom-0px">Is Transferred</label>
                                            </div>

                                          </div>
                                          <!--<div *ngIf="l.IsTransFerred">
                                <i class="fas fa-check-circle color-icon-completed font-size-23px"></i>
                                <label class="margin-bottom-0px">Is Transferred</label>
                              </div>-->
                                          <!--<div class="row" *ngIf="l.IsTransFerred">

                                <div *ngIf="l.IsTransFerred"><i class="fas fa-check-circle color-icon-completed font-size-23px"></i></div>
                                <div *ngIf="l.IsTransFerred"><label class="margin-bottom-0px">Is Transferred</label></div>
                              </div>-->

                                        </td>
                                      </tr>



                                    </tbody>

                                  </table>

                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row margin-left-0px margin-top-15px" *ngIf="GradingModel=='Droplet Culture'">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample9">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingnine">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsenine" aria-expanded="true" aria-controls="collapsenine">
                                Embryo Grading
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" (click)="Addactivity()"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload"
                                    name="upload" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>


                          </div>

                        </div>


                      </div>

                      <div id="collapsenine" class="collapse show" aria-labelledby="headingnine" data-parent="#accordionExample9">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">
                                    <thead class="">
                                      <tr>
                                        <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-0px">DOC &amp; Date  </th>

                                        <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px"> Stage  </th>
                                        <th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Straw#</th>
                                        <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                                        <th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Transfer Count</th>
                                        <!--<th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px"> Is Transferred</th>-->
                                      </tr>
                                    </thead>

                                    <tbody class="table-body">
                                      <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferredController">

                                        <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">
                                          <div>[{{l.DOC}}]</div>
                                          <div class="font-size-11px">{{l.TimeStamp| date:'MMM-dd-yyyy'}}</div>
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px">
                                          {{l.Cellstage}}
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px text-align-center">{{l.StrawNumber}}</td>
                                        <td class="padding-top-0px padding-bottom-0px">{{l.Regrade1}}{{l.Regrade2}}</td>
                                        <td class="padding-top-0px padding-bottom-0px text-align-center text-align-center">{{l.UsedCount}}</td>






                                      </tr>



                                    </tbody>

                                  </table>

                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row margin-left-0px margin-top-15px">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample5">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                Procedures/Tests
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                    name="upload" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row">
                                <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                                  <div class="table-component table-tests">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new">

                                        <tbody class="table-body">

                                          <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                            <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                            <td class="padding-top-4px padding-bottom-4px padding-right-0px">{{RowIndex+1}}</td>
                                            <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                              <div class="height-16px">
                                                <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                              </div>
                                              <div class="row-height-17px">
                                                <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                              </div>
                                              <div class="row-height-17px">
                                                <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                              </div>
                                            </td>
                                            <td class="padding-top-4px padding-bottom-4px">
                                              <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                  </a>-->
                                              <div class="test-icons float-right" *ngIf="EmbryoTransferData2">
                                                <a (click)="delTEST(l)" title="Remove" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                                <a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                </a>
                                              </div>
                                            </td>




                                          </tr>

                                        </tbody>
                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row margin-left-0px margin-top-15px">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample6">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSix">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                Medicines
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                    name="upload" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                        </div>


                      </div>

                      <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionExample6">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                              <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                                <div class="table-component">
                                  <div class="table-responsive">


                                    <table class="table table-striped margin-left-zero width-50-new">
                                      <!--<thead>
                                                              <tr>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                </th>

                                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>


                                                                <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                </th>











                                                              </tr>
                                                            </thead>-->
                                      <tbody class="table-body">

                                        <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                          <td class="padding-top-4px padding-bottom-4px ">{{RowIndex+1}}</td>
                                          <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
    <div class="height-16px" >
      <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
    </div>

  </td>-->
                                          <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.StartDate| date:'MMM-dd-yyyy'}}</td>
                                          <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                          <td class=" padding-top-4px padding-bottom-4px ">{{l.Dosage}}{{l.DurationType}}</td>
                                          <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                          <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                          <td class="padding-top-4px padding-bottom-4px ">
                                            <div class="test-icons float-right" *ngIf="EmbryoTransferData2">
                                              <a (click)="delMedicine(l)" title="Remove" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                              <a (click)="EditMedicine(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                                                <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                              </a>
                                            </div>
                                          </td>
                                          <!--<td class="padding-top-4px padding-bottom-4px">


  </td>-->




                                        </tr>

                                      </tbody>
                                    </table>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitNotes()" #f="ngForm">
                  <div class="accordion" id="accordionExampledate" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdate">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedate" aria-expanded="true" aria-controls="collapsedate">
                                Notes
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsedate" class="collapse show" aria-labelledby="headingdate" data-parent="#accordionExampledate">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-2 padding-right-0px text-align-right margin-top-4px ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Notes </label>
                                </div>


                                <div class="col-md-9">

                                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Notes"
                                            name="EmbryoTransFerEndInfo.Notes"
                                            [(ngModel)]="EmbryoTransFerEndInfo.Notes" minlength="1" maxlength="1000"
                                            #addconcerns_text="ngModel" required></textarea>
                                  <small class="form-text text-danger"
                                         *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                                </div>

                              </div>


                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmit_NextScanDate()" #f="ngForm">
                  <div class="accordion" id="accordionExampledate" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdate">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedate" aria-expanded="true" aria-controls="collapsedate">
                                Notes
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                        </div>


                      </div>

                      <div id="collapsedate" class="collapse show" aria-labelledby="headingdate" data-parent="#accordionExampledate">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row font-size-12px">
                                <div class="col-md-2  text-align-right margin-top-4px ">
                                  <label for="diaplayName" class=" margin-bottom-0px">Notes </label>
                                </div>:


                                <div class="col-md-9 margin-tg-auto">

                                  <!--<div class="date-form">
                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                        <small class="form-text text-danger"
                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                        <a (click)="d1.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>-->


                                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Notes"
                                            name="EmbryoTransFerEndInfo.Notes"
                                            [(ngModel)]="EmbryoTransFerEndInfo.Notes" minlength="1" maxlength="1000"
                                            #addconcerns_text="ngModel" required></textarea>
                                  <small class="form-text text-danger"
                                         *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                                  <label class="margin-bottom-0px ">{{FollicularScanEndInfo.NextDocDate | date:'MMM-dd-yyyy'}}</label>
                                </div>

                              </div>


                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
